import { initializeFaroForApp, signerFaroConfig, getFaroConfig } from '@repo/utils';

const envName = process.env.ENV_NAME || 'integ';
const faroEnvConfig = getFaroConfig(signerFaroConfig, envName);

export const faro = initializeFaroForApp({
  name: 'signer-sdk',
  collectorKey: faroEnvConfig.collectorKey,
  appId: faroEnvConfig.appId,
  environment: envName,
});
